<template>
  <div class="tw-w-full">
    <ul class="tw-grid tw-grid-cols-1 xs:tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-2">
      <li
        v-for="motor in motoresOrdenados(motores)"
        :key="motor.id"
        @click="openModal(motor)"
        :class="[
          modoOperacao == 0 ? 'hover:hover:tw-shadow-xl hover:tw-shadow-emerald-500/10 hover:-tw-translate-y-1 tw-cursor-pointer' : '',
          theme == 'dark' 
            ? 'tw-bg-[#334155]' 
            : 'tw-bg-white',
          'tw-group tw-relative tw-flex tw-items-center tw-gap-2 tw-p-2 tw-shadow-lg tw-rounded-2xl'
        ]"
      >
        <div class="tw-relative tw-flex tw-items-center tw-justify-center">
          <div :class="[
            motor.status === 1 ? 'tw-bg-emerald-500' : 'tw-bg-slate-400',
            'tw-w-12 tw-h-12 tw-rounded-xl tw-flex tw-items-center tw-justify-center'
          ]">
            <img
                src="/images/icons/ventilador2.png"
                alt="Motor Ligado"
                class="tw-w-7 tw-h-7 tw-brightness-0 tw-invert"
                :class="motor.status === 1 ? 'tw-animate-spin' : ''"
            />
          </div>
        </div>

        <div class="tw-flex-1 tw-min-w-0">
          <div class="tw-flex tw-items-center tw-gap-2">
            <h5 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-900'" class="tw-font-bold tw-text-base tw-truncate">
              {{ motor.descricao }}
            </h5>
            <span :class="motor.status === 1 ? 'tw-text-emerald-500' : 'tw-text-slate-500'" class="tw-text-[12px] tw-font-bold tw-uppercase tw-whitespace-nowrap">
              {{ motor.status === 1 ? "Ligado" : "Desligado" }}
            </span>
          </div>
          <small class="tw-text-[10px] tw-text-slate-400 tw-font-medium">{{ aeracaoData }}</small>
        </div>
      </li>
    </ul>

    <div>
      <div v-if="showModal && modoOperacao == 0" class="tw-fixed tw-inset-0 tw-bg-slate-900/60 tw-flex tw-justify-center tw-items-center tw-z-[99999]" @click.self="closeModal">
        <div :class="theme === 'dark' ? 'tw-bg-slate-900 tw-border-slate-800' : 'tw-bg-white tw-border-slate-100'" class="tw-p-8 tw-rounded-[2rem] tw-w-[340px] tw-text-center tw-shadow-2xl tw-border">
          <div :class="selectedMotor.status === 1 ? 'tw-bg-emerald-500/10 tw-text-emerald-500' : 'tw-bg-red-500/10 tw-text-red-500'" class="tw-w-16 tw-h-16 tw-rounded-2xl tw-mx-auto tw-mb-4 tw-flex tw-items-center tw-justify-center">
            <svg class="tw-w-8 tw-h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
          </div>
          
          <h3 :class="theme === 'dark' ? 'tw-text-white' : 'tw-text-slate-900'" class="tw-text-xl tw-font-bold tw-mb-1">Controle Manual</h3>
          <p class="tw-text-slate-500 tw-text-sm tw-mb-6">{{ selectedMotor.descricao }}</p>
          
          <div class="tw-grid tw-grid-cols-2 tw-gap-3">
              <button 
                class="tw-py-3 tw-bg-emerald-600 hover:tw-bg-emerald-500 tw-text-white tw-rounded-xl tw-font-bold tw-text-xs tw-uppercase tw-tracking-widest active:tw-scale-95 disabled:tw-opacity-50" 
                @click="sendCommandManual(1)" 
                :disabled="disable"
              >Ligar</button>
              
              <button 
                class="tw-py-3 tw-bg-slate-200 hover:tw-bg-slate-300 tw-text-slate-700 tw-rounded-xl tw-font-bold tw-text-xs tw-uppercase tw-tracking-widest active:tw-scale-95 disabled:tw-opacity-50" 
                @click="sendCommandManual(0)" 
                :disabled="disable"
              >Desligar</button>
          </div>
          
          <button @click="closeModal" class="tw-mt-6 tw-text-slate-400 tw-text-xs tw-font-semibold hover:tw-text-slate-600">Cancelar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useRoute } from "vue-router";
import { useToast } from "vue-toastification";

export default {
    setup () {
        const route = useRoute();
        const toast = useToast();

        return {
            siloId: route.params.silo,
            toast
        };
    },
    props: {
        motores: {
            type: Array,
            default: () => [],
        },
        aeracaoData: {
            type: [String, Date],
            default: null,
        },
        modoOperacao: {
            type: Number,
            default: 1,
        },
        theme: {
            type: String,
        },
    },
    data() {
        return {
            showModal: false,
            selectedMotor: {},
            disable: false
        };
    },
    methods: {
        motoresOrdenados(motores) {
            return motores.sort((a, b) => a.descricao.localeCompare(b.descricao));
        },
        openModal(motor) {
            this.selectedMotor = motor;
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
            this.selectedMotor = {};
        },
        async sendCommandManual(command) {
            this.disable = true
            const datas = {
                descricao: this.selectedMotor.descricao,
                modulo: this.selectedMotor.modulo,
                saida: this.selectedMotor.saida,
                comando: command,
            };
            try {
                let response = await this.$store.dispatch('silo/SendMotorManualCommand', {"data": datas, "siloId": this.siloId})
                this.toast.info("Comando do motor enviado ao Painel TermoWeb, aguardando confirmação...", { timeout: 3900 });
                let messageId = response.message.message_id;
                setTimeout(async () => {
                    let msg = await this.$store.dispatch("message/fetchMessage", messageId);
                    if (msg.status !== 'processed') {
                        this.toast.error("O painel não conseguiu receber o comando.");
                    } else {
                        this.toast.success("Comando enviado ao motor.");
                    }
                }, 4000);
            } catch (error) {
                this.toast.error(error.response.data.message || "Erro ao enviar comando manual");
            }
            this.disable = false

        }
    },
};
</script>
